import React, { Component } from 'react'
import { connect } from 'react-redux'
import { ListItem } from 'material-ui/List'
import Row from 'muicss/lib/react/row'
import { Link } from 'react-router'
import Avatar from '../../../BadgeHeroesComponents/Avatar'
import { edit_profile_path } from '../../../../routes'

const style = { marginLeft: '20px', marginRight: '20px' }

class UserAvatar extends Component {

  render() {
    const { first_name, last_name, image_url, team } = this.props
    return (
      <Row>
        <Link style={{ textDecoration: 'none' }} to={edit_profile_path()}>
          <ListItem
            style={style}
            innerDivStyle={style}
            nestedListStyle={style}
            leftAvatar={<Avatar size={60} image_url={image_url} />}
            primaryText={
              <div
                className="mui--text-headline" style={style}
              > {`${first_name} ${last_name}`} </div>
            }
            secondaryText={
              <div
                className="mui--text-headline" style={style}
              > {team !== null ? `${team.name}` : ''} </div>
            }
            secondaryTextLines={2}
          />
        </Link>

      </Row>
    )
  }
}

UserAvatar.propTypes = {
  first_name: React.PropTypes.string.isRequired,
  last_name: React.PropTypes.string.isRequired,
  image_url: React.PropTypes.string.isRequired,
  team: React.PropTypes.shape({
    name: React.PropTypes.string,
  }),
}


const mapStateToProps = state => ({
  ...state.user,
})

const mapDispatchToProps = () => ({})


export default connect(mapStateToProps, mapDispatchToProps)(UserAvatar)



// WEBPACK FOOTER //
// ./src/components/Main/Profile/Avatar/index.jsx